<template>
  <DxPopup @hidden="onHidden" :visible="showProcessVPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="850" width="1280" container=".v-application">
    <div class="h-full">
      <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
        <OL type="A" style="font-size:12pt">
          <LI>Thông Tin Chung Về Trang Web http://ebiz.hvs.com.vn:</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Người sử dụng là tất cả các khách hàng có quan hệ mua bán vật tư với công ty đóng tàu HD Hyundai Việt Nam.</LI>
              <LI>Cài đặt Internet Explore:</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>
                    Thêm  'http://*.ibiz.hvs.com.vn'  vào Trusted sites.<br>
                    (1)Mở ' Internet Option' và chọn thẻ 'Security'<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_Option.jpg`)" width="600"><br>
                    (2)Gõ tên trang web rồi nhấn nút 'Add' như hình dưới:<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_00_setting.jpg`)" width="300"><br>
                  </LI>
                  <LI>
                    Tắt chế độ chặn Pop-up của Internet Explore: Như hình sau..<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_01_turnoff_popup.jpg`)" width="600"><br>
                    hoặc cài đặt theo hình sau:<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_02_Option.jpg`)" width="600"><br>
                    <img :src="require(`@/assets/images/etc/ie_setting_03_set_blocker.jpg`)" width="600"><br><br>
                  </LI>
                  <LI>
                    Không sử dụng các toolbar như google toolbar , yahoo toolbar.<br>
                    <img :src="require(`@/assets/images/etc/ie_setting_04_toolbar.jpg`)" width="600"><br><br>
                  </LI>
                </OL>
              <LI>Đăng nhập : Tên tài khoản (USER ID) và mật khẩu (PASSWORD)</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tên tài khoản (USER ID):</LI>
                    <OL type="a" style="font-size:10pt;">
                      <LI>3.1.1.	Tải khoản sử dụng là một mã số khách hàng (mỗi nhà cung cấp có một mã số khách hàng riêng do HVS tạo ra, ví dụ: Công ty A có mã số khách hàng là 10001).</LI>
                      <LI>
                      Nếu khách hàng nào chưa có mã khách hàng xin vui lòng liên hệ với chúng tôi qua địa chỉ :
                      Bộ phận Mua hàng, Phòng Vật tư, Công ty TNHH Đóng tàu HD Hyundai Việt Nam,
                      Số 01, Mỹ Giang, Ninh Phước, Ninh Hòa, Khánh Hòa, Việt Nam,
                      Điện thoại: 0583.622101, Fax: 0583.622047, Thư điện tử: hvs@hvs.com.vn.

                      </LI>
                    </OL>
                  <LI>Mật khẩu (PASSWORD):</LI>
                    <OL type="a" style="font-size:10pt">
                      <LI>Mật khẩu bắt đầu khởi tạo như sau: v + mã số khách hàng (ví dụ: User ID: 10001, Password: 10001).</LI>
                      <LI>Trang web cho phép người sử dụng tự thay đổi mật khẩu hiện tại.</LI>
                      <LI>Mỗi 3 tháng một lần, bạn phải thay đổi lại mật khẩu mới.</LI>
                      <LI>Nếu người sử dụng mất hay là quên mật khẩu, trong trường hợp này người sử dụng phải trực tiếp đến và mang theo giấy tờ có liên quan để chứng minh với phòng vật tư trước khi phòng vật tư tạo lại mật khẩu mới, nhằm bảo mật thông tin của người sử dụng.</LI>
                    </OL>
                  <LI>Mục đích của yêu cầu báo giá là để tìm ra một nhà cung cấp có mức giá và tiêu chuẩn kỹ thuật của vật tư mua về phải phù hợp với chi phí định sẵn và chất lượng của sản phẩm làm ra phải đạt tiêu chuẩn.<br><br></LI>
                </OL>
            </OL>
          <LI>Quy Trình Làm Việc Của Website:</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Quotation Request (Yêu cầu báo giá): HVS sẽ chọn những nhà cung cấp có tiềm năng và gửi yêu cầu báo giá.</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Mỗi yêu cầu báo giá có một mã số như sau:  QT + YY (năm) + MM (tháng) + ‘-’ + số seri (QT0905-0001).</LI>
                  <LI>Tiến hành nhận yêu cầu báo giá từ HVS.</LI>
                  <LI>Tạo báo giá từ yêu cầu báo giá đã nhận trước khi gửi sang HVS.</LI>
                  <LI>Sau khi lưu, thông tin sẽ bị mã hóa khi hiển thị và không thể xóa cũng như thay đổi thông tin của báo giá.</LI>
                  <LI>Gửi sang HVS trong thời gian còn hiệu lực của yêu cầu báo giá.</LI>
                  <LI>HVS so sánh báo giá nếu sự chênh lệch quá cao về mức giá giữa các nhà cung cấp thì sẽ tiến hành báo giá lại nhằm yêu cầu nhà cung cấp tạo báo giá tốt hơn, ngược lại HVS sẽ tiến hành gửi yêu cầu xác minh giá.<br><br></LI>
                </OL>
              <LI>Re-Quotation (Báo giá lại):</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tiến hành nhận yêu cầu báo giá lại từ HVS.</LI>
                  <LI>Tạo báo giá từ yêu cầu báo giá lại đã nhận.</LI>
                  <LI>Sau khi lưu, thông tin sẽ bị mã hóa khi hiển thị và không thể xóa cũng như thay đổi thông tin của báo giá.</LI>
                  <LI>Gửi sang HVS trong thời gian còn hiệu lực của yêu cầu báo giá lại.<br><br></LI>
                </OL>
              <LI>Price Indication (Xác minh giá): HVS sẽ gửi một mức giá đích đến từng nhà cung cấp nhằm yêu cầu xác minh giá.</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tiến hành nhận yêu cầu xác minh giá từ HVS.</LI>
                  <LI>Tạo báo giá từ yêu cầu xác minh giá đã nhận.</LI>
                  <LI>Sau khi lưu, thông tin sẽ bị mã hóa khi hiển thị và không thể xóa cũng như thay đổi thông tin của báo giá.</LI>
                  <LI>Gửi sang HVS trong thời gian còn hiệu lực của yêu cầu xác minh giá.</LI>
                  <LI>Nếu nhiều hơn một nhà cung cấp có mức giá bằng nhau hay tất cả các nhà cung cấp đều có mức giá cao hơn mức giá đích mà HVS đưa ra thì sẽ tiến hành đấu thầu, ngược lại HVS sẽ chọn nhà cung cấp nào có mức giá bằng hoặc thấp hơn mức giá đích mà HVS đưa ra để tiến hành làm phiếu yêu cầu giao hàng.<br><br></LI>
                </OL>
              <LI>Bid (Đấu thầu) :</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tiến hành nhận yêu cầu báo giá đấu thầu từ HVS.</LI>
                  <LI>Tạo báo giá từ yêu cầu báo giá đấu thầu đã nhận.</LI>
                  <LI>Sau khi lưu, thông tin sẽ bị mã hóa khi hiển thị và không thể xóa cũng như thay đổi thông tin của báo giá.</LI>
                  <LI>Gửi sang HVS trong thời gian còn hiệu lực của yêu cầu báo giá đấu thầu.</LI>
                  <LI>Nếu nhiều hơn một nhà cung cấp có mức giá đấu thầu bằng nhau thì sẽ tiến hành đấu thầu lại, ngược lại HVS sẽ chọn nhà cung cấp nào có mức giá thấp nhất để tiến hành làm phiếu yêu cầu giao hàng.<br><br></LI>
                </OL>
              <LI>Re-Bid (Đấu thầu lại):</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tiến hành nhận yêu cầu báo giá đấu thầu lại từ HVS.</LI>
                  <LI>Tạo báo giá từ yêu cầu báo giá đấu thầu lại đã nhận..</LI>
                  <LI>Sau khi lưu, thông tin sẽ bị mã hóa khi hiển thị và không thể xóa cũng như thay đổi thông tin của báo giá.</LI>
                  <LI>Gửi sang HVS trong thời gian còn hiệu lực của yêu cầu báo giá đấu thầu lại.</LI>
                  <LI>Nếu mức giá đấu thầu lại vẫn bằng nhau giữa các nhà cung cấp thì chúng tôi tiến hành mời đại diện của các nhà cung cấp đó đến công ty chúng tôi trực tiếp thảo luận nhằm chọn ra một nhà cung cấp có mức giá tốt nhất.<br><br></LI>
                </OL>
              <LI>P.O (Phiếu yêu cầu giao hàng):</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Sau khi thỏa thuận mức giá, HVS sẽ gửi phiếu yêu cầu giao hàng đến công ty bạn.</LI>
                  <LI>Tiến hành nhận phiếu yêu cầu giao hàng.</LI>
                  <LI>Tạo phiếu giao hàng dựa vào những điều khoản đã thỏa thuận.<br><br></LI>
                </OL>
              <LI>Delivery (Phiếu giao hàng):</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>Tạo phiếu giao hàng khi đã nhận phiếu yêu cầu giao hàng.</LI>
                  <LI>Khi hàng hóa mua để sửa chữa tàu nhưng tàu hoàn thành và đi trước khi nhà cung cấp hàng hóa tạo phiếu mua hàng (Delivery Note), người phụ trách mua hàng của HVS phải báo cáo trưởng phòng, nếu trưởng phòng đồng ý cho khách hàng giao hàng thì khách hàng tiến hành tạo phiếu giao hàng (Delivery Note), ngược lại thì hệ thống sẽ tự động khóa chức năng tạo mới phiếu giao hàng (Delivery Note).</LI>
                  <LI>Khách hàng phải giao hàng trong vòng 5 ngày kể từ ngày tạo phiếu giao hàng (Delivery Note), nếu quá 5 ngày mà khách hàng chưa giao hàng thì hệ thống sẽ tự động xóa Delivery Note đó khỏi hệ thống.</LI>
                  <LI>Chúng tôi không chấp nhận phiếu mua hàng mà thông tin không khớp với thực tế giao hàng hoặc phiếu giao hàng đã bị chỉnh sửa bằng bút mực. Sau khi chúng tôi tiến hành nhập kho phiếu giao hàng thì hệ thống sẽ không cho phép chỉnh sửa thông tin của phiếu giao hàng đó.<br><br></LI>
                </OL>
            </OL>
        </OL>
      </DxScrollView>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'

export default {
  name: 'processVPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView
  },
  props: {
    showProcessVPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'Hip Process(Vietnamese)',
       openChk: false
     }
  },
  watch: {
    'showProcessVPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
    },
    onHidden(e) {
      this.$emit('update:showProcessVPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>